import React from 'react'

export default function Store() {
    return (
        <div>
            <br />
            <br />
            <br />
            <br />
            <div class="section-header">


                <p><span>Places To Stay</span></p>
            </div>
            <img src={require('../assets/img/d1.webp')} class="store1img" id="imgstore1" alt="logo" />
            <br />
            <br />
            <div class="row gy-4">

                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                    <div class="chef-member">
                        <div class="member-img">
                            <img src={require('../assets/img/hotel 1.avif')} class="storeimg123" id="img123store" alt="logo" />
                            <div class="social">
                                <a href=""><i class="bi bi-twitter"></i></a>
                                <a href=""><i class="bi bi-facebook"></i></a>
                                <a href=""><i class="bi bi-instagram"></i></a>
                                <a href=""><i class="bi bi-linkedin"></i></a>
                            </div>
                            <br />
                            <h5>Disney Residence Inn Hotel</h5>
                            <h6>Enjoy special rooms at the hollywood-themed hotel featuring restaurent and a piano-themed outdoor pool and Disney's California Adventure theme parks.</h6>
                            <br />
                            <button><a href="https://disneyworld.disney.go.com/resorts/more/residence-inn/" className='rounded-pill m-5'>Book Now</a></button>
                        </div>
                        <br />
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                    <div class="chef-member">
                        <div class="member-img">
                            <img src={require('../assets/img/hotel2.webp')} class="storeimg123" id="img123store" alt="logo" />
                            <div class="social">
                                <a href=""><i class="bi bi-twitter"></i></a>
                                <a href=""><i class="bi bi-facebook"></i></a>
                                <a href=""><i class="bi bi-instagram"></i></a>
                                <a href=""><i class="bi bi-linkedin"></i></a>
                            </div>
                            <br />
                            <h5>Disney Anaheim Hotel</h5>
                            <h6>The Home2 Suites by Hilton Anaheim Resort, CA is conveniently located across from the entrance to Disneyland. </h6>
                            <br />
                            <button><a href="https://www.agoda.com/en-in/super-8-by-wyndham-anaheim-disneyland-drive/hotel/los-angeles-ca-us.html?finalPriceView=1&isShowMobileAppPrice=false&cid=1914936&numberOfBedrooms=&familyMode=false&adults=1&children=0&rooms=1&maxRooms=0&checkIn=2023-07-17&isCalendarCallout=false&childAges=&numberOfGuest=0&missingChildAges=false&travellerType=-1&showReviewSubmissionEntry=false&currencyCode=INR&isFreeOccSearch=false&tag=49ea4ea7-2b56-4daa-a936-ade668b5b7fb&isCityHaveAsq=false&tspTypes=8,8&los=1&searchrequestid=f3e8a3de-c060-4730-914d-5fc46a6b2d8a" className='rounded-pill m-5'>Book Now</a></button>
                        </div>
                        <br />
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                    <div class="chef-member">
                        <div class="member-img">
                            <img src={require('../assets/img/paris1.webp')} class="storeimg123" id="img123store" alt="logo" />
                            <div class="social">
                                <a href=""><i class="bi bi-twitter"></i></a>
                                <a href=""><i class="bi bi-facebook"></i></a>
                                <a href=""><i class="bi bi-instagram"></i></a>
                                <a href=""><i class="bi bi-linkedin"></i></a>
                            </div>
                            <br />
                            <h5>Disney Conrad orlando  Hotel</h5>
                            <h6>Inside the lush 1,100 acres at Evermore Orlando Resort is a captivating retreat. Buffered by a nature preserve, Conrad Orlando offers everything.</h6>
                            <br />
                            <button><a href="https://www.hilton.com/en/hotels/orlcici-conrad-orlando/" className='rounded-pill m-5'>Book Now</a></button>
                        </div>
                        <br />
                    </div>
                </div>



            </div>
        </div>
    )
}
